import React, { Component } from 'react'
import { Link } from 'react-router'

import LoadingDots from 'components/Loading/LoadingDots'
import IconChevronDown from 'components/Icons/ChevronDown'
import AnimationFade from 'components/Animation/AnimationFade'

import cn from 'classnames'
import s from './Button.scss'

export default class extends Component {
  state = {
    errorState: false,
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error && !this.props.error) {
      this.setState({
        errorState: true,
      })
      this.errorStateTimeout = setTimeout(() => {
        this.setState({
          errorState: false,
        })
      }, 1000)
    }
  }
  componentWillUnmount() {
    clearTimeout(this.errorStateTimeout)
  }
  render() {
    const {
      color,
      className,
      to,
      size,
      prev,
      next,
      error,
      href,
      ghost,
      stickyBottom,
      icon,
      plain,
      children,
      loading,
      rect,
      buttonRef,
      ...otherProps
    } = this.props
    const { errorState } = this.state
    const classes = cn(
      {
        [s.standard]: !ghost && !plain && !next && !prev,
        [s.ghost]: ghost,
        [s.plain]: plain,
        [s.next]: next,
        [s.prev]: prev,
        [s.icon]: icon,
        [s[color]]: color,
        [s.loading]: loading,
        [s.lg]: size === 'lg',
        [s.sm]: size === 'sm',
        [s.xs]: size === 'xs',
        [s.stickyBottom]: stickyBottom,
        [s.error]: errorState,
        [s.rect]: rect,
      },
      className
    )

    if (to) {
      return (
        <Link className={classes} to={to} {...otherProps}>
          <AnimationFade in={!loading}>
            <span>{children}</span>
          </AnimationFade>
          <AnimationFade in={loading}>
            <LoadingDots className={s.dots} />
          </AnimationFade>
          {(next || prev) && <IconChevronDown size={12} />}
        </Link>
      )
    } else if (href) {
      return (
        <a className={classes} href={href} {...otherProps}>
          <AnimationFade in={!loading}>
            <span>{children}</span>
          </AnimationFade>
          <AnimationFade in={loading}>
            <LoadingDots className={s.dots} />
          </AnimationFade>
          {(next || prev) && <IconChevronDown size={12} />}
        </a>
      )
    }
    return (
      <button className={classes} type="button" {...otherProps}>
        <AnimationFade in={!loading}>
          <span>{children}</span>
        </AnimationFade>
        <AnimationFade in={loading}>
          <LoadingDots className={s.dots} />
        </AnimationFade>
        {(next || prev) && <IconChevronDown size={12} />}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Button/Button.jsx